import React from 'react';
import PropTypes from "prop-types";
import {FacebookShareButton, FacebookIcon, LinkedinShareButton, LinkedinIcon, TwitterShareButton, TwitterIcon} from 'react-share';
import {isBrowser} from "react-device-detect";
import api from 'api';
import SVGIcon from "../../../../components/SVGIcon";

function SocialMediaShares(props) {
  const hasShares = _.find(props.survey.shares, share => !!share);
  if (!hasShares) {
    return null;
  }

  const addUserPoints = () => {
    api.surveyResponse.postShare(props.surveyResponse);
  };

  const url = window.location.href.split('?')[0];

  return (
    <div className="social-media-shares lg-float-right d-lg-block d-inline-block">
      <h3 className={"d-block d-lg-none color-default"}>UDOSTĘPNIJ ANKIETĘ:</h3>
      {props.survey.shares.facebook && <span><FacebookShareButton url={url} className="pointer" hashtag="#ankieta" onShareWindowClose={addUserPoints}><SVGIcon size={"42px"} icon={'../../../../s/img/icon/facebook-icon.svg'} /></FacebookShareButton></span>}
      {props.survey.shares.linkedIn && <span><LinkedinShareButton url={url} className="pointer" onShareWindowClose={addUserPoints}><SVGIcon size={"42px"} icon={'../../../../s/img/icon/linkedin-icon.svg'} /></LinkedinShareButton></span>}
      {props.survey.shares.twitter && <span><TwitterShareButton url={url} className="pointer" onShareWindowClose={addUserPoints}><SVGIcon size={"42px"} icon={'../../../../s/img/icon/X-icon.svg'} /></TwitterShareButton></span>}
    </div>
  )
}

SocialMediaShares.propTypes = {
  surveyResponse: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  survey: PropTypes.shape({
    shares: PropTypes.shape({
      facebook: PropTypes.bool.isRequired,
      linkedIn: PropTypes.bool.isRequired,
      twitter: PropTypes.bool.isRequired
    }),
  }),
};

export default SocialMediaShares;